// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-logo-area{padding:0;height:100vh}.text-center{text-align:center}.login-btn{transition:background-color .3s}.login-btn:disabled{background-color:gray;border-color:gray;cursor:not-allowed;color:#fff}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
